<div class="am-content">
  <div class="main-content">
    <div class="page-head">
      <h2 class="title">Statistics</h2>
      <ol class="breadcrumb">
        <li>
          <a [routerLink]="NAVIGATIONS.STATISTICS.route">{{
            NAVIGATIONS.STATISTICS.name
          }}</a>
        </li>
        <li class="active">{{ NAVIGATIONS.STATISTICS.name }}</li>
      </ol>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default" style="padding: 2rem">
          <div class="row" style="margin-bottom: 24px">
            <div class="col-md-12">
              <iframe
                title="Metrics Report"
                [src]="powerBiMetricsReportUrl"
                frameborder="0"
                allowFullScreen="true"
                style="height: 80dvh; width: 100%;"
              ></iframe>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-xs-6">
              <div class="form-group">
                <h5>Date filter</h5>
                <div class="input-group">
                  <div class="form-control date-range-control" (click)="rangePicker.open()">
                    <mat-date-range-input
                      id="dateRangeFilter"
                      [formGroup]="dateRange"
                      [rangePicker]="rangePicker"
                    >
                      <input
                        matStartDate
                        formControlName="start"
                        placeholder="Start date"
                        autocomplete="off"
                        readonly
                      />
                      <input
                        matEndDate
                        formControlName="end"
                        placeholder="End date"
                        autocomplete="off"
                        readonly
                      />
                    </mat-date-range-input>
                  </div>
                  <span
                    class="input-group-addon btn btn-primary"
                    (click)="rangePicker.open()"
                    ><i class="icon-th s7-date"></i
                  ></span>
                </div>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button type="button" class="btn btn-default" matDateRangePickerCancel>Cancel</button>
                    <button type="button" class="btn btn-primary" matDateRangePickerApply>Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </div>
            </div>
            <div class="col-md-8 col-xs-6">
              <button
                type="submit"
                class="btn btn-primary"
                style="margin-top: 31px; height: 44px; float: right"
                (click)="synchronizeMetrics()"
              >
                Sync Metrics Last Day
              </button>
            </div>
          </div>
          <div class="row">
            <hr />
            <div class="col-md-3 col-3">
              <div
                class="panel panel-default text-center statistic-summary"
              >
                <div class="bold" style="font-size: 1.2rem">Unique users</div>
                <div style="font-size: 2.2rem; font-weight: bold">
                  {{ userCount }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-3">
              <div
                class="panel panel-default text-center statistic-summary"
              >
                <div class="bold" style="font-size: 1.2rem">
                  Average prompts per user
                </div>
                <div style="font-size: 2.2rem; font-weight: bold">
                  {{ averageQueriesPerUser | number : "1.2-2" }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-3">
              <div
                class="panel panel-default text-center statistic-summary"
              >
                <div class="bold" style="font-size: 1.2rem">
                  Average response time
                </div>
                <div style="font-size: 2.2rem; font-weight: bold">
                  {{ avgResponseTimeSec | number : "1.2-2" }} sec
                </div>
              </div>
            </div>
            <div class="col-md-3 col-3">
              <div
                class="panel panel-default text-center statistic-summary"
              >
                <div class="bold" style="font-size: 1.2rem">Files consumed</div>
                <div style="font-size: 2.2rem; font-weight: bold">
                  {{ fileCount }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <hr />
            <div class="col-md-12">
              <h4 class="bold">Top files by prompt consumption</h4>
            </div>
            <div class="col-md-12">
              <div class="form-group" style="margin-bottom: 1rem">
                <h5>Show top {{ topFilesControl.value }} files</h5>
                <div class="ng-select-container">
                  <ng-select
                    [items]="[5, 10, 25, 50]"
                    bindLabel=""
                    bindValue=""
                    [clearable]="false"
                    [searchable]="false"
                    [formControl]="topFilesControl"
                    placeholder="Select files to show"
                    class="show-n-select"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th class="col-file-name bold">File</th>
                      <th class="col-file-count bold">
                        Prompt consumption count
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of topFiles">
                      <td class="col-file-name">{{ file.key }}</td>
                      <td class="col-file-count">{{ file.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-6">
              <div class="widget widget-pie">
                <div class="row chart-container">
                  <div class="col-md-6">
                    <div
                      id="widget-top-files"
                      class="chart"
                      style="padding: 0px; position: relative"
                    ></div>
                  </div>
                  <div class="col-md-6">
                    <div class="legend"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <hr />
            <div class="col-md-12">
              <h4 class="bold">Top countries by prompt consumption</h4>
            </div>
            <div class="col-md-12">
              <div class="form-group" style="margin-bottom: 1rem">
                <h5>Show top {{ topCountriesControl.value }} countries</h5>
                <div class="ng-select-container">
                  <ng-select
                    [items]="[5, 10, 25, 50]"
                    bindLabel=""
                    bindValue=""
                    [clearable]="false"
                    [searchable]="false"
                    [formControl]="topCountriesControl"
                    placeholder="Select countries to show"
                    class="show-n-select"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th class="bold">Country</th>
                      <th class="bold">Prompt consumption count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let country of topCountries">
                      <td>{{ country.country }}</td>
                      <td>{{ country.totalQueries }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-sm-6">
              <div id="world-map" class="world-map"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
